import * as R from 'remeda';
import type { Page as ApiPage } from '@rossum/api-client/pages';

export type SplitPageIndex = {
  idByNumber: Record<number, number>;
  numberById: Record<number, number>;
};

export const createSplitPageIndex = (pages: ApiPage[]): SplitPageIndex => ({
  idByNumber: R.mapToObj(pages, page => [page.number, page.id]),
  numberById: R.mapToObj(pages, page => [page.id, page.number]),
});
